import { Chevron } from "@/components/ui/Chevron";

/**
 * Scanning banner — shown while the orchestration is in the `scanning`
 * state. Today the patterns are hardcoded (we have four registered);
 * Step 5 of the redesign moves to fetching them from /.well-known/ptrn.
 *
 * Purpose: take the user from "blank loader" to "I can see what's
 * happening". This is the cheapest, biggest-impact T0 improvement —
 * the LLM is doing real work behind the scenes (shortlist, fit scoring)
 * and the user should see the patterns being weighed.
 */
const KNOWN_PATTERNS = [
  "servicebus",
  "eventgrid",
  "logicapps",
  "apim-functions",
] as const;

export function ScanningBanner() {
  return (
    <section className="rounded-lg border border-primary/40 bg-primary/5 p-6">
      <p className="font-mono text-xs uppercase tracking-widest text-muted-foreground mb-2">
        <Chevron pulse className="mr-2" /> scanning
      </p>
      <p className="text-base font-medium mb-3">
        Evaluating patterns against your scenario…
      </p>
      <ul className="space-y-1 text-sm text-muted-foreground font-mono">
        {KNOWN_PATTERNS.map((p) => (
          <li key={p}>
            <span className="text-primary mr-2">·</span>
            {p}
          </li>
        ))}
      </ul>
    </section>
  );
}
